import script from "./AperturePhotometryDiagnostics.vue?vue&type=script&setup=true&lang=js"
export * from "./AperturePhotometryDiagnostics.vue?vue&type=script&setup=true&lang=js"

import "./AperturePhotometryDiagnostics.vue?vue&type=style&index=0&id=0afe997c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0afe997c"]])

export default __exports__